import { IconAppsFilled, IconCardsFilled, IconCreditCardFilled, IconFileAnalyticsFilled, IconFileSettingsFilled, IconGasStationFilled, IconHomeFilled } from '@tabler/icons-react';

export const menuConfig = [
    {
        label: 'Accueil',
        icon: <IconHomeFilled size={20} stroke={1.5} />,
        to: '/',
    },
    {
        label: 'Prises carburants',
        icon: <IconGasStationFilled size={20} stroke={1.5} />,
        to: '/prise-carburant',
        keywords: ['transaction', 'consommation'],
    },
    {
        label: 'Paiements',
        icon: <IconCreditCardFilled size={20} stroke={1.5} />,
        to: '/paiement',
        keywords: ['transaction', 'paiement'],
    },
    {
        label: 'Cartes',
        icon: <IconCardsFilled size={20} stroke={1.5} />,
        to: '/carte',
        keywords: ['recharge', 'solde', 'activation', 'blocage', 'pin', 'limite'],
        description: 'Gestion & recharge des cartes',
    },
    {
        label: 'Rapport',
        icon: <IconFileAnalyticsFilled size={20} stroke={1.5} />,
        children: [
            { label: 'Relevé client', href: '/releve-client' },
            { label: 'Livraison carte', href: '/livraison-carte-report', roles: ['Admin', 'AdminViewer'] },
        ],
    },
    {
        label: 'Extra',
        icon: <IconAppsFilled size={20} stroke={1.5} />,
        children: [{ label: 'FAQ', href: '/faq' }],
    },
    {
        label: 'Administration',
        icon: <IconFileSettingsFilled size={20} stroke={1.5} />,
        roles: ['Admin'],
        children: [
            { label: 'POS - Master Data', href: '/point-of-sale-master-data' },
            { label: 'Soldes Clients', href: '/client' },
            { label: 'Comptes utilisateurs', href: '/compte-utilisateur' },
            { label: 'Configuration de prix', href: '/config-prix' },
            { label: 'Permissions', href: '/permission' },
            { label: "Journal d'opérations", href: '/journalisation' },
            { label: "Journal d'erreurs", href: '/log' },
            { label: 'A propos', href: '/about' },
        ],
    },
];
